import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../auth-n-routing/auth-service.service";
import { RefillsHandlerService } from "../../../api-handlers/refills-handler.service";
import { DateHandlerService } from "../../../commons/date-handler.service";
import { TraPaginatorComponent } from "./paginator/tra-paginator.component";
import { Travel } from "../../../models/travel";
import { Refill } from "../../../models/refill";
import { TravelsHandlerService } from "../../../api-handlers/travels-handler.service";
import { User } from "../../../models/user";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { VehiclesHandlerService } from "../../../api-handlers/vehicles-handler.service";
import { SnackBarHandlerService } from "../../../commons/snack-bar-handler.service";
import { AssignCarToUserComponent } from "../../../dialogs/assign-car-to-user/assign-car-to-user.component";
import { ExportXLSPDF } from "../../../commons/export-xls-pdf.service";
import { CompileWarrantComponent } from "../../../dialogs/compile-warrant/compile-warrant.component";
import { InsertRefillsComponent } from "../../../dialogs/insert-refills/insert-refills.component";
import { EndTravelComponent } from "../../../dialogs/end-travel/end-travel.component";
import { ChangeCarToUserComponent } from "../../../dialogs/change-car-to-user/change-car-to-user.component";
import { saveAs as importedSaveAs } from "file-saver";

@Component({
  selector: "app-travels",
  templateUrl: "./travels.component.html",
  styleUrls: ["./travels.component.scss"],
})
export class TravelsComponent implements OnInit {
  travels_list: Travel[];
  @Output() statusChanged = new EventEmitter();
  @ViewChild(AssignCarToUserComponent, { static: false })
  assignCarToUserDialog: AssignCarToUserComponent;
  @ViewChild(ChangeCarToUserComponent, { static: false })
  changeCarToUserDialog: ChangeCarToUserComponent;
  @ViewChild(TraPaginatorComponent, { static: false })
  paginator: TraPaginatorComponent;
  @ViewChild(CompileWarrantComponent, { static: false })
  compileWarrantDialog: CompileWarrantComponent;
  @ViewChild(InsertRefillsComponent, { static: false })
  insertRefillsDialog: InsertRefillsComponent;
  endTravelDialog?: BsModalRef;
  disableCartaCircolazioneMap: { [plate: string]: boolean } = {};

  bsModalRef: BsModalRef;

  isInProgress = false;

  dom_elements = {
    small_screen: false,
  };

  reloadList() {
    this.isInProgress = true;
    this.travelsHandlerService.reloadTravelsListAndCount().then((res) => {
      this.travels_list = this.travelsHandlerService.travels_list;

      // this.travelsHandlerService.travels_list.forEach((travel) => {
      //   if (travel.travelApproved() && travel.travelStarted() && !travel.travelEnded()) {
      //     this.checkCartaCircolazione(travel).then((exists) => {
      //       this.disableCartaCircolazioneMap[travel.vehicle.plate] = !exists;
      //       this.changeDetector.detectChanges();
      //     });
      //   }
      // });

      this.isInProgress = false;
      this.changeDetector.detectChanges();
    });
  }

  constructor(
    public authService: AuthService,
    private changeDetector: ChangeDetectorRef,
    public dateHandler: DateHandlerService,
    private modalService: BsModalService,
    private snackBarHandler: SnackBarHandlerService,
    private vehiclesService: VehiclesHandlerService,
    public travelsHandlerService: TravelsHandlerService,
    private refillsHandlerService: RefillsHandlerService,
    private router: Router,
    public exportService: ExportXLSPDF
  ) {
    this.dom_elements.small_screen = window.screen.width < 470;
  }

  ngOnInit() {
    this.authService.authChange.subscribe((u: User) => {
      if (u) {
        this.reloadList();
      }
    });
  }

  routeExists(travel: Travel): boolean {
    if (travel.route !== '' && typeof travel.route === 'string') {
        travel.route = JSON.parse(travel.route);
    }

    return travel.route !== '';
  }

  approveTravel(travel: Travel) {
    this.assignCarToUserDialog.showDialog(travel);
  }

  declineTravel(travel: Travel) {
    const r = confirm("Sicuro di voler rifiutare la richiesta di viaggio?");
    if (r === true) {
      this.travelsHandlerService
        .declineTravel(travel)
        .then((travelNew: Travel) => {
          travel.status.id = travelNew.status.id;
          travel.status.name = travelNew.status.name;
          this.statusChanged.next(undefined);
          this.reloadList();
        });
    }
  }

  forceCloseTravel(travel: Travel) {
    const r = confirm("Sicuro di voler interrompere la richiesta di viaggio?");
    if (r === true) {
      this.travelsHandlerService
        .forceCloseTravel(travel)
        .then((travelNew: Travel) => {
          travel.started_at = travelNew.started_at;
          travel.ended_at = travelNew.ended_at;
          this.statusChanged.next(undefined);
          this.reloadList();
        });
    }
  }

  changeAssignedVehicle(travel: Travel) {
    // console.log("change vehicle");
    this.changeCarToUserDialog.showDialog(travel);
  }

  travelsStatusChanged() {
    this.paginator.refreshCurrentPage();
  }

  vehicleAssigned() {
    this.statusChanged.next(undefined);
    this.reloadList();
  }

  viewRefillsForTravel(travel: Travel) {
    if (travel.refills_counted) {
      this.refillsHandlerService.refills_list_props.filter_column =
        "refills_expanded.rfl_travel_id";
      this.refillsHandlerService.refills_list_props.filter_value =
        travel.id.toString();
      this.refillsHandlerService.changeFilterName("ID viaggio");
      this.refillsHandlerService.reloadRefillsListAndCount();
      this.router.navigate(["./dashboard/refills"]);
    } else {
      this.snackBarHandler.showSnackbar(
        "Non ci sono rifornimenti per questo viaggio",
        3000
      );
    }
  }
  compileWarrant(travel: Travel) {
    this.compileWarrantDialog.showDialog(travel);
    this.reloadList();
  }

  insertRefills(travel: Travel) {
    /* NON ACCEDE ALLA VIDEOCAMERA DA DIALOG APERTA CON UN TEMPLATE
		this.insertRefillsDialog.showDialog(travel);
		this.reloadList();
		*/
    travel.route = JSON.stringify(travel.route);
    const initialState = {
      travelToRefill: travel,
    };
    this.bsModalRef = this.modalService.show(ModalContentComponent, {
      initialState,
    });
    this.reloadList();
  }

  endTravel(travel: Travel) {
    travel.route = JSON.stringify(travel.route);
    const initialState: ModalOptions = {
      initialState: {
        travelToEnd: travel,
      },
      ignoreBackdropClick: true,
      keyboard: false,
    };

    this.endTravelDialog = this.modalService.show(
      EndTravelComponent,
      initialState
    );

    this.endTravelDialog.onHide.subscribe(() => {
      this.reloadList();
    });
  }

  getVehicleDocument(travel: Travel) {
    this.vehiclesService
      .downloadTagliando(travel.vehicle.plate)
      .then((blob) => {
        // const file = new Blob([blob], {type: 'application/pdf'});
        importedSaveAs(blob, "tagliando_" + travel.vehicle.plate + ".pdf");
      });
  }

  removePlatePrefix(plate: string): string {
    let checkedPlate = plate;

    if (plate.substring(0, 3) === "CRI") {
      checkedPlate = plate.substring(3, plate.length);
    }

    return checkedPlate;
  }

  checkCartaCircolazione(travel: Travel): Promise<boolean> {
    const plate = this.removePlatePrefix(travel.vehicle.plate);
    return this.vehiclesService
      .checkCartaCircolazione(plate)
      .then((res) => res.esisteVersioneFirmata);
  }

  getCartaCircolazione(travel: Travel) {
    const plate = this.removePlatePrefix(travel.vehicle.plate);

    this.vehiclesService.downloadCartaCircolazione(plate).then((blob) => {
      importedSaveAs(blob, "carta_digitale_" + travel.vehicle.plate + ".pdf");
    });
  }

  exportPDF(travel) {
    // const path = "../../assets/imgs/cri_logo.png";
    const path = "../../assets/imgs/emblema_trasparente.png";
    let imageData: any;
    this.travelsHandlerService.getImageLogo(path).subscribe(
      (data) => {
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            imageData = reader.result;
            // Prende tutti i rifornimenti per il viaggio
            this.refillsHandlerService
              .getRefillsByTravelID(travel.id, 0)
              .then(
                (refills: Refill[]) => {
                  this.exportService.showTravelPdf(travel, refills, imageData);
                },
                (err) => {
                  console.log(err);
                }
              )
              .catch(() => {
                this.snackBarHandler.showSnackbar(
                  "Attenzione, impossibile caricare i rifornimento per il viaggio",
                  3000
                );
              });
          },
          false
        );
        if (data) {
          reader.readAsDataURL(data);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  exportPDFMilitare(travel) {
    const path = "../../assets/imgs/dim_militare.jpg";
    let imageData: any;
    this.travelsHandlerService.getImageLogo(path).subscribe(
      (data) => {
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            imageData = reader.result;
            this.exportService.showTravelPdfMilitare(travel, imageData);
          },
          false
        );
        if (data) {
          reader.readAsDataURL(data);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  cancelTravelRequest(travel: Travel) {
    console.log(travel.id + "viaggio cancellato");
    // this.dom_elements.cancelTrip.is_running = true;

    const r = confirm("Sicuro di voler annullare la richiesta di viaggio?");
    if (r === true) {
      this.travelsHandlerService
        .cancelRequestTravel(travel)
        .then((travelNew: Travel) => {
          travel = new Travel(undefined);
          travel.user = this.authService.getAuthenticatedUser();
          // this.viewStartTrip();
          this.reloadList();
        })
        .catch(() => {})
        .then(() => {
          // this.dom_elements.cancelTrip.is_running = false;
        });
    } else {
      console.log(travel.id + "annulla");
    }
  }
}

// ***** DIALOG

@Component({
  selector: "app-modal-content",
  template: `
    <div class="modal-header">
      <h5 class="modal-title">Rifornimento</h5>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" #div>
      <div style="margin-bottom: 10px; text-align:center;">
        <b>viaggio #{{ travelToRefill.id }}</b>
      </div>
      <h6 style="text-align: center;">
        Attenzione! Ricordati di impostare il livello del carburante e di
        scattare le foto prima del rifornimento.
      </h6>
      <div class="mb-1">
        Liv carburante:
        <rating
          [max]="5"
          [(ngModel)]="refill.fuel_level"
          [customTemplate]="tt"
        ></rating>

        <ng-template #tt let-i="index" let-v="value">
          <button class="btn btn-{{ i < v ? 'alert' : 'default' }}">
            {{ i == 0 ? "&#48;" : "" }}
            {{ i == 1 ? "&#188;" : "" }}
            {{ i == 2 ? "&#189;" : "" }}
            {{ i == 3 ? "&#190;" : "" }}
            {{ i == 4 ? "&#49;" : "" }}
          </button>
        </ng-template>
      </div>

      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <span class="input-group-text width59" id="basic-addon1">Lt</span>
        </div>
        <input
          type="number"
          min="1"
          max="999"
          class="form-control"
          placeholder="Quantità litri"
          [(ngModel)]="refill.quantity"
          aria-label="Quantità litri"
          aria-describedby="basic-addon1"
        />
      </div>

      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <span class="input-group-text width59" id="basic-addon12">€</span>
        </div>
        <input
          type="number"
          min="1"
          max="999"
          class="form-control"
          placeholder="Spesa in euro"
          [(ngModel)]="refill.amount"
          aria-label="Spesa in euro"
          aria-describedby="basic-addon1"
        />
      </div>

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text width59" id="basic-addon13">Km</span>
        </div>
        <input
          type="number"
          min="1"
          max="999999"
          class="form-control"
          placeholder="Kilometri attuali"
          [(ngModel)]="refill.kilometers"
          aria-label="Kilometri attuali"
          aria-describedby="basic-addon1"
        />
      </div>

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text width59" id="basic-addon15">Data</span>
        </div>
        <input
          type="text"
          class="form-control"
          #dp="bsDatepicker"
          style="height: auto;"
          bsDatepicker
          [bsConfig]="{ dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false }"
          [(bsValue)]="refill.made_at"
        />
        <timepicker
          [(ngModel)]="refill.made_at"
          [showMeridian]="false"
        ></timepicker>
      </div>

      <div [hidden]="dom_elements.box_url64" class="mt-5">
        <video
          #videoBoxElement
          id="videoBoxElement"
          style="width:100%;height:310px;"
          playsinline
          [hidden]="no_camera"
        ></video>
        <button
          (click)="takePictureBox()"
          class="btn btn-primary btn-block"
          [disabled]="no_camera"
        >
          <span class="oi oi-camera-slr"></span> Scatta foto a cruscotto
        </button>
        <div class="custom-file">
          <input
            type="file"
            accept="image/*"
            class="custom-file-input"
            id="fsLoadImageBox"
            size="24"
            (change)="imageBoxLoaded($event)"
          />
          <label class="custom-file-label" for="fsLoadImageBox"
            >Carica foto cruscotto da libreria...</label
          >
        </div>
      </div>

      <div [hidden]="!dom_elements.box_url64" class="mt-5 mb-5">
        <canvas id="cnvsBox" class="canvas_recive"></canvas>
        <button (click)="deletePicBox()" class="btn btn-primary btn-block">
          <span class="oi oi-circle-x"></span> Scarta foto a cruscotto
        </button>
      </div>

      <div [hidden]="!dom_elements.recive_url64 && !dom_elements.box_url64">
        <div [hidden]="dom_elements.recive_url64">
          <video
            #videoRecElement
            id="videoRecElement"
            style="width:100%;height:310px;"
            playsinline
            [hidden]="no_camera"
          ></video>
          <button
            (click)="takePictureRecive()"
            class="btn btn-primary btn-block"
            [disabled]="no_camera"
          >
            <span class="oi oi-camera-slr"></span> Scatta foto a ricevuta
          </button>
          <div class="custom-file">
            <input
              type="file"
              accept="image/*"
              class="custom-file-input"
              id="fsLoadImageRec"
              size="24"
              (change)="imageRecLoaded($event)"
            />
            <label class="custom-file-label" for="fsLoadImageRec"
              >Carica foto ricevuta da libreria...</label
            >
          </div>
        </div>

        <div [hidden]="!dom_elements.recive_url64">
          <canvas id="cnvsRec" class="canvas_recive"></canvas>
          <button (click)="deletePicRecive()" class="btn btn-primary btn-block">
            <span class="oi oi-circle-x"></span> Scarta foto a ricevuta
          </button>
        </div>
      </div>
    </div>
    <!-- end modal body-->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">
        Annulla
      </button>
      <button type="button" class="btn btn-primary" (click)="doRefill()">
        Rifornimento
      </button>
    </div>
  `,
  styles: [
    `
      @import "../../../../assets/custom_bootstrap-4.1.1/main.min.css";
      .btn-camera {
        z-index: 100;
      }
      .canvas_recive {
        width: 100%;
      }
      .overflow-auto {
        overflow: auto;
        position: relative;
      }
      .height250 {
        height: 250px;
      }
      .width59 {
        width: 59px;
      }
      timepicker ::ng-deep table > tbody > tr > td > input {
        font-size: 12px !important;
      }
      .centered {
        padding: 30px 15px 0;
        margin: 0 auto;
      }
      @media only screen and (min-width: 470px) {
        .centered {
          width: 440px;
        }
      }
    `,
  ],
})
export class ModalContentComponent implements OnInit, AfterViewInit {
  travelToRefill: Travel;
  refill: Refill = new Refill(undefined);
  @ViewChild("videoRecElement", { static: false }) videoRecElement: any;
  @ViewChild("videoBoxElement", { static: false }) videoBoxElement: any;
  @Output() refillsCompleted = new EventEmitter<boolean>();
  @Output() isLoading = new EventEmitter<boolean>();
  no_camera = false;
  hidden_box = true;
  search_text = "";
  videoBox: any;
  videoRec: any;
  videoBoxSrc: any;
  videoRecSrc: any;

  dom_elements = {
    is_loading: false,
    box_url64: "",
    recive_url64: "",
    first_played: false,
    second_played: false,
    addRefuel_btn: {
      is_running: false,
      txt_run: "SALVATAGGIO IN CORSO...",
      txt_not_run: "SALVA RIFORNIMENTO",
    },
    insertRefuel: {
      is_running: false,
      txt_run: "CREAZIONE RIFORNIMENTO IN CORSO...",
      txt_not_run: "SALVA RIFORNIMENTO",
    },
    active_step: 1,
  };

  constructor(
    public modalRef: BsModalRef,
    public travelsHandlerService: TravelsHandlerService,
    public travelsService: TravelsHandlerService,
    public snackBarHandler: SnackBarHandlerService,
    public refillsService: RefillsHandlerService,
  ) {}

  ngOnInit() {
    /*this.list.push('PROFIT!!!');
    console.log(this.div);*/
  }

  ngAfterViewInit(): void {
    this.dom_elements.active_step = 1;
    this.addEnter();
  }

  doRefill() {
    /*console.log("effettua rifornimento");
    this.refillsCompleted.emit();
    this.modalRef.hide();*/

    console.log("effettua rifornimento");
    this.dom_elements.insertRefuel.is_running = true;
    this.isRefillComplete()
      .then((res) => {
        if (res) {
          this.getCurrentPosition((lat, lon, alt) => {
            this.refill.latitude = lat;
            this.refill.longitude = lon;
            this.refill.altitude = alt;

            this.refill.travel = this.travelToRefill;

            this.refillsService
              .addRefill(this.refill)
              .then(
                (res2) => {
                  this.resetRefill();
                  this.refillsCompleted.emit();
                  this.modalRef.hide();

                  this.snackBarHandler.showSnackbar(
                    "Salvataggio eseguito con successo",
                    1000
                  );
                  this.dom_elements.insertRefuel.is_running = false;
                },
                (err) => {
                  console.log(err);
                }
              )
              .catch(() => {
                this.snackBarHandler.showSnackbar(
                  "Attenzione, impossibile salvare. Riprova",
                  3000
                );
                this.dom_elements.insertRefuel.is_running = false;
              })
              .then(() => {});
          });
        } else {
          this.dom_elements.insertRefuel.is_running = false;
        }
      })
      .catch(() => {
        this.snackBarHandler.showSnackbar(
          "Attenzione, impossibile salvare. Riprova",
          3000
        );
        this.dom_elements.insertRefuel.is_running = false;
      });
  }

  isRefillComplete(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (!this.refill.quantity) {
        this.snackBarHandler.showSnackbar("Impostare quantità in litri", 3000);
        resolve(false);
      } else if (!this.refill.amount) {
        this.snackBarHandler.showSnackbar("Impostare importo speso", 3000);
        resolve(false);
      } else if (!this.refill.kilometers) {
        this.snackBarHandler.showSnackbar("Impostare i chilometri", 3000);
        resolve(false);
      } else if (!this.refill.fuel_level) {
        this.snackBarHandler.showSnackbar(
          "Impostare il livello del serbatoio prima del rifornimento",
          3000
        );
        resolve(false);
      } else if (!this.refill.made_at) {
        this.snackBarHandler.showSnackbar("Impostare una data valida", 3000);
        resolve(false);
      } else if (!this.refill.box_pic) {
        this.snackBarHandler.showSnackbar("Scattare foto cruscotto", 3000);
        resolve(false);
      } else if (!this.refill.recive_pic) {
        this.snackBarHandler.showSnackbar("Scattare foto scontrino", 3000);
        resolve(false);
      } else if (isNaN(Number(this.refill.kilometers))) {
        this.snackBarHandler.showSnackbar("Valore kilometri non valido", 3000);
        resolve(false);
      } else if (isNaN(Number(this.refill.amount))) {
        this.snackBarHandler.showSnackbar("Valore spesa euro non valido", 3000);
        resolve(false);
      } else if (isNaN(Number(this.refill.quantity))) {
        this.snackBarHandler.showSnackbar(
          "Valore quantità litri non valido",
          3000
        );
        resolve(false);
      } else if (
        Number(this.refill.amount) / Number(this.refill.quantity) < 0.65 ||
        Number(this.refill.amount) / Number(this.refill.quantity) > 3.0
      ) {
        this.snackBarHandler.showSnackbar(
          "Importo non coerente con la quantità di litri",
          3000
        );
        resolve(false);
      } else {
        this.travelsService
          .getMaxKm(this.travelToRefill)
          .then((res) => {
            console.log(res);
            if (
              Number(this.refill.kilometers) < res ||
              Number(this.refill.kilometers) <
                Number(this.travelToRefill.start_kilometers)
            ) {
              this.snackBarHandler.showSnackbar(
                "Chilometri attuali minori del numero di chilometri impostati precedentemente",
                3000
              );
              resolve(false);
            } else {
              resolve(true);
            }
          })
          .catch((er) => {
            resolve(false);
          });
      }
    });
  }

  getCurrentPosition(callbackFunction) {
    callbackFunction(null, null, null);
    // navigator.geolocation.getCurrentPosition((position) => {
    // 	callbackFunction(position.coords.latitude, position.coords.longitude, position.coords.altitude);
    // }, (err) => {
    // 	callbackFunction(null, null, null);
    // });
  }

  resetRefill() {
    this.refill = new Refill(undefined);
    this.refill.travel = this.travelToRefill;
  }

  addEnter() {
    if (this.dom_elements.active_step === 1) {
      this.startLoading();
      const browser = <any>navigator;

      browser.getMedia =
        browser.getUserMedia ||
        browser.webkitGetUserMedia ||
        browser.mozGetUserMedia ||
        browser.msGetUserMedia;
      if (!browser.getMedia) {
        alert(
          "Your browser doesn't have support for the navigator.getUserMedia interface."
        );
        this.stopLoading(true);
      } else {
        // Request the camera.
        try {
          browser.getMedia(
            { video: { facingMode: { exact: "environment" } }, audio: false },
            (stream) => {
              this.videoBoxSrc = stream;
              this.videoRecSrc = stream;
              this.videoRec.srcObject = this.videoRecSrc;
              this.videoBox.srcObject = this.videoBoxSrc;

              this.activateRecivePhoto();
              this.activateBoxPhoto();
            },
            (err_) => {
              browser.mediaDevices.enumerateDevices().then((devices) => {
                let dev_trovato = null;
                devices.forEach((device) => {
                  if (device.kind === "videoinput") {
                    if (dev_trovato === null) {
                      dev_trovato = device;
                    } else {
                      if (device.label.toLowerCase().indexOf("back") !== -1) {
                        dev_trovato = device;
                      }
                    }
                  }
                });

                browser.getMedia(
                  {
                    video: { deviceId: { exact: dev_trovato.deviceId } },
                    audio: false,
                  },
                  (stream) => {
                    this.videoBoxSrc = stream;
                    this.videoRecSrc = stream;
                    this.videoRec.srcObject = this.videoRecSrc;
                    this.videoBox.srcObject = this.videoBoxSrc;
                    this.activateRecivePhoto();
                    this.activateBoxPhoto();
                  },
                  (err) => {
                    alert(
                      "There was an error with accessing the camera stream: " +
                        err.name
                    );
                    this.stopLoading(true);
                  }
                );
              });
            }
          );
        } catch (e) {
          this.stopLoading(true);
        }
      }
    }
  }

  startLoading() {
    this.no_camera = false;
    this.dom_elements.is_loading = true;
    this.resetRefill();
    this.search_text = "";

    setTimeout(() => {
      this.videoBox = this.videoBoxElement.nativeElement;
      this.videoRec = this.videoRecElement.nativeElement;
      this.videoRec.srcObject = null;
      this.videoBox.srcObject = null;
    });

    this.travelsService
      .getMaxKm(this.travelToRefill)
      .then((res) => {
        this.refill.kilometers = res.toString();
      })
      .catch((er) => {});

    this.videoBoxSrc = null;
    this.videoRecSrc = null;

    this.dom_elements.first_played = false;
    this.dom_elements.second_played = false;
    this.dom_elements.recive_url64 = "";
    this.dom_elements.box_url64 = "";
    this.isLoading.next(true);
  }

  stopLoading(force: boolean) {
    if (force) {
      this.no_camera = true;
    }
    if (
      force ||
      (this.dom_elements.first_played && this.dom_elements.second_played)
    ) {
      this.dom_elements.is_loading = false;
      this.isLoading.next(false);
    }
  }

  addLeave() {
    this.deactivateAll();
  }

  deactivateRecivePhoto() {
    if (this.videoRec) {
      this.videoRec.srcObject = null;
      if (this.videoRecSrc) {
        this.videoRecSrc.getVideoTracks().forEach((track) => {
          track.stop();
        });
      }
      this.videoRec.pause();
    }
  }

  deactivateBoxPhoto() {
    if (this.videoBox) {
      this.videoBox.srcObject = null;
      if (this.videoBoxSrc) {
        this.videoBoxSrc.getVideoTracks().forEach((track) => {
          track.stop();
        });
      }
      this.videoBox.pause();
    }
  }

  activateBoxPhoto() {
    this.videoBox.play();
    this.videoBox.onplaying = () => {
      this.dom_elements.second_played = true;
      this.stopLoading(false);
    };
  }

  activateRecivePhoto() {
    this.videoRec.play();
    this.videoRec.onplaying = () => {
      this.dom_elements.first_played = true;
      this.stopLoading(false);
    };
  }

  deactivateAll() {
    this.deactivateRecivePhoto();
    this.deactivateBoxPhoto();
  }

  takePictureRecive() {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsRec");

    const hegihtToSet =
      (canvas.width * this.videoRec.videoHeight) / this.videoRec.videoWidth;

    this.drawPictureRec(this.videoRec, canvas.width, hegihtToSet);
  }

  drawPictureRec(toDraw: any, widthToSet, heightToSet) {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsRec");
    const ctx = canvas.getContext("2d");

    canvas.height = heightToSet;
    canvas.width = widthToSet;

    ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

    const contentType = "image/png";
    this.dom_elements.recive_url64 = canvas.toDataURL(contentType);
    this.refill.recive_pic = this.dataURItoBlob(this.dom_elements.recive_url64);

    this.activateBoxPhoto();
  }

  takePictureBox() {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsBox");

    const hegihtToSet =
      (canvas.width * this.videoBox.videoHeight) / this.videoBox.videoWidth;

    this.drawPictureBox(this.videoRec, canvas.width, hegihtToSet);
  }

  drawPictureBox(toDraw: any, widthToSet, heightToSet) {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsBox");
    const ctx = canvas.getContext("2d");

    canvas.height = heightToSet;
    canvas.width = widthToSet;

    ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

    const contentType = "image/png";
    this.dom_elements.box_url64 = canvas.toDataURL(contentType);
    this.refill.box_pic = this.dataURItoBlob(this.dom_elements.box_url64);

    this.activateBoxPhoto();
  }

  deletePicRecive() {
    this.dom_elements.recive_url64 = "";
    this.activateRecivePhoto();
  }

  deletePicBox() {
    this.dom_elements.box_url64 = "";
    this.activateBoxPhoto();
  }

  dataURItoBlob(dataURI) {
    const binary = atob(dataURI.split(",")[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: "image/jpg",
    });
  }

  imageBoxLoaded(event) {
    console.log(event);
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event2) => {
        const image = new Image();
        image.onload = () => {
          const canvas = <HTMLCanvasElement>document.getElementById("cnvsBox");
          const hegihtToSet = (canvas.width * image.height) / image.width;
          this.drawPictureBox(image, canvas.width, hegihtToSet);
        };
        image.src = event2.target["result"] as string;
      };
      reader.readAsDataURL(event.target.files[0]);
      event.target.value = null;
    }
  }

  imageRecLoaded(event) {
    console.log(event);
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event2) => {
        const image = new Image();
        image.onload = () => {
          const canvas = <HTMLCanvasElement>document.getElementById("cnvsRec");
          const hegihtToSet = (canvas.width * image.height) / image.width;
          this.drawPictureRec(image, canvas.width, hegihtToSet);
        };
        image.src = event2.target["result"] as string;
      };
      reader.readAsDataURL(event.target.files[0]);
      event.target.value = null;
    }
  }
}
